type BrandOpts = { brandName: string; supportEmail: string };

/** intlify/vue-i18n treats `@` as linked-message syntax; escape for literal @ in messages. */
function escapeIntlifyAt(s: string): string {
  return s.replace(/@/g, "{'@'}");
}

/**
 * Replaces `{brandName}` and `{supportEmail}` placeholders in every string leaf
 * (locale files keep placeholders; values are injected at app init).
 */
export function applyBrandToLocaleMessages<T>(messages: T, opts: BrandOpts): T {
  const { brandName: b, supportEmail: e } = opts;
  const brandForMessages = escapeIntlifyAt(b);
  const emailForMessages = escapeIntlifyAt(e);

  function walk(val: unknown): unknown {
    if (typeof val === "string") {
      return val
        .replace(/\{brandName\}/g, brandForMessages)
        .replace(/\{supportEmail\}/g, emailForMessages);
    }
    if (val !== null && typeof val === "object" && !Array.isArray(val)) {
      const o = val as Record<string, unknown>;
      const out: Record<string, unknown> = {};
      for (const k of Object.keys(o)) {
        out[k] = walk(o[k]);
      }
      return out;
    }
    if (Array.isArray(val)) {
      return val.map(walk);
    }
    return val;
  }

  return walk(messages) as T;
}
